import axios from 'axios';
import store from '@/store';
import router from '@/router/index';
import { Message } from 'element-ui'
import { env, currentEnv } from './config.js';
let current = currentEnv();

let service = axios.create({
    baseURL: env[current].api,
    timeout: 60000 // request timeout
});

let ossService = axios.create({
    baseURL: env[current].ossApi,
    timeout: 30000 // oss request timeout
});

service.interceptors.request.use(config => {
    // config.headers['CLIENT'] = '2000';
    config.headers['Content-Type'] = 'application/json';

    // token
    if (store.getters.token) {
        config.headers['BIT-TOKEN'] = store.getters.token
    }

    // uid
    if (store.getters.uid) {
        config.headers['BIT-UID'] = store.getters.uid
    }

    //app-id
    config.headers['APP-ID'] = '5c0f13c90c879831740123a2';
    let currentUrl = matchUrl(config.url);
    if (currentUrl) {
        config.url = currentUrl;
    }
    if(config.url.indexOf("v2/") != -1) {
        config.url = config.url.replace('/v1', '') 
    };
    if (store.getters.pushId) {
        config.headers['PUSH-ID'] = store.getters.pushId;
    }
    
    return config
}, error => {
    Promise.reject(error)
})

service.interceptors.response.use(
    res => {
        if(res.config.responseType == "blob") {
            return res
        }else if (res.data) {
            if (res.data.subCode == "user.invalid-auth-token" || res.data.errorCode == 9050001) {
                let rPath = router.history.current.path;
                store.dispatch('changeToken', null);
                Message({ message: '登录已过期,请您重新登录', type: 'error' });
                if (rPath && rPath != '/login') {
                    router.push({ path: '/login' });
                    // router.push('/login?url=' + encodeURIComponent(rPath) );
                } else {
                    router.push('/login');
                }
            } else if ((res.data.code && res.data.code !== 0) || (res.data.errorCode && res.data.errorCode !== 0)) {
                Message({ message: res.data.subMsg ||res.data.msg || res.data.errorMsg, type: 'error' })
            }
        }

        return res.data || res;
    }, error => {

        if (error.message.indexOf('timeout') !== -1) {
            Message({ message: '请求超时，请检查网络...', type: 'error' });
            return service.request(originalRequest)
        } else {
            Message({ message: error.message, type: 'error' })
        }
        return Promise.reject(error)
    }
)

// ossService.interceptors.request.use(function (config) {
//     return config;
// }, function (error) {
//     return Promise.reject(error);
// })

ossService.interceptors.response.use(res => res.data || res, error => {
    Message({ message: '链接错误,请联系管理员', type: 'error' })
    return Promise.reject(error)
})

function matchUrl(url) {
    if (url.split('/hardware/').length > 1) {
        return env[current].hardwareApi + url.split('/hardware/')[1];
    } else if (url.split('/palm/').length > 1) {
        return env[current].palmApi + url.split('/palm/')[1];
    } else if (url.split('setting/').length > 1) {
        return env[current].hardwareApi + url;
    } else {
        return false;
    }
}

export default service;
export { service, ossService};



// WEBPACK FOOTER //
// ./src/utils/request.js